import Path from "../../services/paths";
import ForcastReportAction from "../actions/forcastReportAction";
import utils from "../common/utils";
import axios from "axios";


class ForcastReportMiddleware {
    static postForcastAccuracyAnalytics(
        selectedCategory,
        selectedBrand,
        selectedSku,
        selectedSegment,
        selectedForecast,
        selectedRegion,
        switchFlag,
        selectedYear
    ) {
        let url = switchFlag ? `${Path.POST_FORCAST_ACCURACY_REGINOL_ANALYTICS}?` : `${Path.POST_FORCAST_ACCURACY_ANALYTICS}?`;

        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }
        if (Array.isArray(selectedSku)) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }
        if (Array.isArray(selectedSegment)) {
            selectedSegment.forEach(element => {
                url += `segment=${element}&`;
            });
        }

        if (Array.isArray(selectedCategory) && selectedForecast) {
            selectedRegion.forEach(element => {
                url += `region=${element}&`;
            });
        }

        url += `forecasted=${selectedForecast}&`;

        url = url.slice(0, -1);

        return dispatch => {
            dispatch(ForcastReportAction.forcastaccuracyRequest());
            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.error) {
                                // console.log("ERROR", res.error);
                            } else {
                                dispatch(
                                    ForcastReportAction.forcastaccuracySuccessul(res)
                                );
                            }
                        })
                        .catch(error => {
                            // console.log("IN CATCH");
                            dispatch(ForcastReportAction.forcastaccuracyFailed(error));
                        });
                })
                .catch(error => {
                    dispatch(ForcastReportAction.forcastaccuracyFailed(error));
                });
        };
    }

    static postForcastAccuracyV2Analytics(
        selectedCategory,
        selectedBrand,
        selectedSku,
        selectedRegion,
        selectedReportType,
        selectedGraphType,
        selectedYear,
        selectedCoreType,
        selectedStandPoint,
        selectedIntervention,
        selectedActiveStatus,
        selectedIsVolume,
        selectedCut,
        selectAllMSKU
    ) {
        let url;
        // let url =switchFlag? `${Path.POST_FORCAST_ACCURACY_REGINOL_ANALYTICS}?`:`${Path.POST_FORCAST_ACCURACY_ANALYTICS}?`;
        if (selectedIntervention[0].value === "Human") {
            url = `${Path.POST_FORCAST_ACCURACY_REGINOL_ANALYTICS_LATEST_HUMAN}?`
        }
        if (selectedIntervention[0].value === "Machine") {
            url = `${Path.POST_FORCAST_ACCURACY_REGINOL_ANALYTICS_LATEST}?`
        }
        if (Array.isArray(selectedCategory)) {
            selectedCategory.forEach(element => {
                url += `category=${element}&`;
            });
        }

        if (Array.isArray(selectedBrand)) {
            selectedBrand.forEach(element => {
                url += `brand=${element}&`;
            });
        }
        if (Array.isArray(selectedSku) && !selectAllMSKU) {
            selectedSku.forEach(element => {
                url += `master_sku=${element}&`;
            });
        }

        if (Array.isArray(selectedCategory)) {
            selectedRegion.forEach(element => {
                url += `region=${element}&`;
            });
        }

        if (Array.isArray(selectedCoreType)) {
            selectedCoreType.forEach(element => {
                url += `core_type=${element}&`;
            });
        }

        if (selectedReportType.length > 0 && selectedReportType[0].label === 'Weekly') {
            url += `is_ytd=${false}&`;
            url += `is_weekly=${true}&`
        }

        if (selectedReportType.length > 0 && selectedReportType[0].label === 'Monthly') {
            url += `is_ytd=${false}&`;
            url += `is_weekly=${false}&`;
        }

        if (selectedReportType.length > 0 && selectedReportType[0].label === 'YTD') {
            url += `is_ytd=${true}&`;
            url += `is_weekly=${false}&`;
        }

        if (selectedGraphType.length > 0 && selectedGraphType[0].label === 'Primary') {
            url += `is_primary=${true}&`;
        } else {
            url += `is_primary=${false}&`;
        }
        if (selectedIsVolume[0].value || !selectedIsVolume[0].value) {
            url += `is_case=${selectedIsVolume[0].value}&`;
        }

        if(selectedActiveStatus.length>0){
            console.log(selectedActiveStatus)
            if(selectedActiveStatus[0].label==='Activated'){url += `activated=${1}&`;}
            if(selectedActiveStatus[0].label==='Non-Activated'){url += `activated=${0}&`;}
            if(selectedActiveStatus[0].label==='All'){url += `activated=${1}&activated=${0}&`;}
        }
        if (selectedYear.length > 0) {
            url += `year=${selectedYear[0].value}&`;
        }
        if (selectedCut) {
            url += `pivot=${selectedCut}&`;
        }
        if (selectAllMSKU || !selectAllMSKU) {
            url += `msku_select_all=${selectAllMSKU}&`;
        }
        
        if(selectedStandPoint.length > 0){
            url += `standpoint=${selectedStandPoint[0]}&`;
        }
        url = url.slice(0, -1);

        return dispatch => {
            dispatch(ForcastReportAction.forcastaccuracyv2Request());
            utils
                .get_token()
                .then(token => {
                    axios({
                        method: "GET",
                        url: url,
                        headers: {
                            Authorization: `Bearer ${token}`
                        }
                    })
                        .then(res => {
                            if (res.error) {
                                // console.log("ERROR", res.error);
                            } else {
                                dispatch(
                                    ForcastReportAction.forcastaccuracyv2Successul(res)
                                );
                            }
                        })
                        .catch(error => {
                            // console.log("IN CATCH");
                            dispatch(ForcastReportAction.forcastaccuracyv2Failed(error));
                        });
                })
                .catch(error => {
                    dispatch(ForcastReportAction.forcastaccuracyv2Failed(error));
                });
        };
    }



}


export default ForcastReportMiddleware;
